/** @format */

import { findLocalizedData } from '@/i18n/utils/find-localized-data';
import { TLocale } from '@/utils/gatsby/types';
import { TRoom } from './declarations';

export const utilityCalculateRoomURL = ({
  room,
  locale,
  fullUrl,
}: {
  room?: TRoom;
  locale: TLocale;
  fullUrl?: boolean;
}) => {
  const localizedData = findLocalizedData(locale, room);
  if (!localizedData) return '';

  if (fullUrl) return localizedData.url;

  const splitUrl = localizedData.url.split('/');
  return `/${splitUrl[4]}/${splitUrl[5]}/`;
};

export const utilityGetRoomMetaTag = (locale: TLocale, room?: TRoom) => {
  const localizedData = findLocalizedData(locale, room);
  if (!localizedData) return { metaTitle: '', metaDescription: '' };
  return { metaTitle: localizedData?.metaTitle || '', metaDescription: localizedData?.metaDescription || '' };
};

export const utilityGetRoomInfo = (locale: TLocale, room?: TRoom) => {
  const localizedData = findLocalizedData(locale, room);
  return {
    title: localizedData?.title || '',
    description: localizedData?.description || '',
  };
};
